module.exports = __webpack_public_path__ + "img/tarj4-4.50ba434f.svg";